// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3QEgh","overflowing":"ReadFullNote_overflowing__1tqnV"};